import { render } from "./CvCard.vue?vue&type=template&id=1f229879&scoped=true"
import script from "./CvCard.vue?vue&type=script&lang=js"
export * from "./CvCard.vue?vue&type=script&lang=js"

import "./CvCard.vue?vue&type=style&index=0&id=1f229879&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f229879"]])

export default __exports__